// Design tokens (12.5) — since Phase 16.5.2 the object lives in packages/theme so the field
// app and the review console (apps/review) cannot drift. This module is a re-export so no
// `~/theme` import in apps/ui changes. Never hard-code a hex in component code.
export * from '@glass/theme';
